// Not i18next's default `i18nextLng`: that key still holds a stale `en` in every
// affected browser, and a fresh key sidesteps them all without a migration (D17).
export const LANGUAGE_STORAGE_KEY = 'b2oLng';
